/**
 * Appends a `RelayState` query parameter to `baseUrl`, encoding `path` so that
 * nested query strings (e.g. `/foo?a=1&b=2`) survive the redirect round-trip
 * instead of being parsed as additional query parameters of the outer URL.
 */
export function append(baseUrl: string, path: string): string {
  return `${baseUrl}?RelayState=${encodeURIComponent(path)}`;
}
